import { makeStyles } from "@material-ui/core";

export const useAnalitycsMainCard = makeStyles((theme) => ({
  mainLink: {
    margin: "5px 10px",
    color: theme.palette.functionalColors.dark,
  },
}));
